// General Definitions

document.addEventListener('DOMContentLoaded', () => {
  const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
  const RECIPROCAL_GR = 1 / GOLDEN_RATIO;
  const DURATION = RECIPROCAL_GR;

  const ease = CustomEase.create('custom', 'M0,0,C0.3,0.3,0.4,1,1,1');
  const bounceInEaseOne = CustomEase.create(
    'bounceInEaseOne',
    'M0,0,C0.3,0.3,0.4,1,1,1'
  );
  const bounceInEaseTwo = CustomEase.create(
    'bounceInEaseTwo',
    'M0,0,C0.55,0,0.69,1,1,1'
  );
  const bounceInEaseThree = CustomEase.create(
    'bounceInEaseThree',
    'M0,0,C0.19,0,0.67,1,1,1'
  );

  gsap.config({
      autoSleep: 60,
      nullTargetWarn: false
  })
    
  gsap.defaults({
    ease: ease,
    duration: DURATION
  })

  gsap.registerEffect({
    name: 'bounceIn',
    extendTimeline: true,
    defaults: {
      duration: DURATION / 1.2,
      repeat: 0,
      paused: false,
      transformOrigin: 'center bottom'
    },
    effect: (targets, config) => {
      const tl = gsap.timeline({
        paused: config.paused,
        repeat: config.repeat,
        defaults: {
          duration: config.duration,
          transformOrigin: config.transformOrigin
        }
      });

      tl.set(targets, { opacity: 1, overwrite: true });

      tl.fromTo(
        targets,
        { scale: 1 },
        { 
          scale: 1.05, 
          ease: bounceInEaseOne, 
          duration: config.duration * 0.5
        }
      );
      tl.to(targets, { 
        scale: 0.97, 
        delay: 0.05, 
        ease: bounceInEaseTwo 
      });
      tl.to(targets, { 
        scale: 1, 
        ease: bounceInEaseThree 
      });

      return tl;
    }
  });  
  
  const sectionRef = document.querySelector('.not-found-container');
  
  if (!sectionRef) return;

  const elementsList = {
    title: sectionRef.querySelector('.not-found-heading'),
    subtitle: sectionRef.querySelector('.not-found-sub-heading'),
    toons: sectionRef.querySelector('.not-found-stickers'),
    goBackButton: sectionRef.querySelector('.not-found-button')
  };

  gsap.set(
    [
      elementsList.title,
      elementsList.subtitle,
      elementsList.toons,
      elementsList.goBackButton
    ],
    {
      opacity: 0.8
    }
  );

  const tl = gsap.timeline({
    paused: true,
    smoothChildTiming: true 
  });

  tl.add(gsap.effects.bounceIn(elementsList.title), 'same');
  tl.add(
    gsap.effects.bounceIn(elementsList.subtitle, {
      transformOrigin: 'center top'
    }),
    'same+=10%'
  );
  tl.add(gsap.effects.bounceIn(elementsList.toons), '<2%');
  tl.add(gsap.effects.bounceIn(elementsList.goBackButton), '<4%');

  tl.play();
});